import type { ComponentType } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { BarChart3, ClipboardList, BookMarked, AppWindow, MailWarning, ShieldCheck } from 'lucide-react';
import type { LucideProps } from 'lucide-react';
import MainLayout from '../../../components/layout/MainLayout';
import styles from './CorreoModule.module.css';

interface CorreoTab {
  to: string;
  label: string;
  icon: ComponentType<LucideProps>;
  /** Solo la pestaña índice usa `end` para no marcarse activa en las sub-rutas. */
  end?: boolean;
}

/**
 * GPP-202603 — Módulo «Servicio de Correo» (solo admin). Contenedor del submódulo:
 * aporta el chrome del portal (MainLayout) y la navegación por pestañas entre sus áreas
 * (estadísticas, reportes, catálogos, aplicaciones, no entregables, auditoría). Cada área
 * se renderiza en el <Outlet>. El acceso ya está protegido por la ruta (requiredRole="admin").
 */
const TABS: CorreoTab[] = [
  { to: '/admin/correo', end: true, label: 'Estadísticas', icon: BarChart3 },
  { to: '/admin/correo/historial', label: 'Reportes', icon: ClipboardList },
  { to: '/admin/correo/catalogos', label: 'Catálogos', icon: BookMarked },
  { to: '/admin/correo/aplicaciones', label: 'Aplicaciones', icon: AppWindow },
  { to: '/admin/correo/no-entregables', label: 'No entregables', icon: MailWarning },
  { to: '/admin/correo/auditoria', label: 'Auditoría', icon: ShieldCheck },
];

export default function CorreoLayout() {
  return (
    <MainLayout
      pageTitle="Servicio de Correo"
      pageSubtitle="Estadísticas, reportes y gestión del servicio centralizado de notificaciones por correo (Amazon SES)."
    >
      <nav className={styles.tabs} aria-label="Secciones del servicio de correo">
        {TABS.map(({ to, end, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => (isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab)}
          >
            <Icon size={16} aria-hidden />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className={styles.panel}>
        <Outlet />
      </div>
    </MainLayout>
  );
}
